import React, { ReactNode, useMemo } from 'react'

import { useLocation } from 'components/ReactRouterProvider/context'
import useWaypointBreadcrumbs from 'components/WaypointNavigator/use-breadcrumbs.tsx'

type Context = {
  breadcrumbs?: URLSearchParams | null
}
const ctx = React.createContext<Context>({
  breadcrumbs: null,
})

const BreadcrumbsManager = ({
  name,
  searchId,
  children,
}: {
  name: string
  searchId: string | undefined
  children: ReactNode
}) => {
  const location = useLocation()
  const waypointCrumbs = useWaypointBreadcrumbs(location.pathname, location.search, name)
  const value = useMemo(() => {
    const params = new URLSearchParams(waypointCrumbs)
    if (searchId !== undefined) {
      params.set('rosterRefId', searchId)
    }
    return {
      breadcrumbs: params,
    }
  }, [waypointCrumbs, searchId])
  return <ctx.Provider value={value}>{children}</ctx.Provider>
}

export const useLocalizedBreadcrumbs = () => {
  const { breadcrumbs } = React.useContext(ctx)
  if (breadcrumbs === undefined) {
    throw new Error('useLocalizedBreadcrumbs must be used within a BreadcrumbsManager')
  }
  return breadcrumbs
}

export default BreadcrumbsManager
